import moment from 'moment';

import {
    formatThaiDateUi,
    getCreateDateTime
} from '../../utils/DateUtils';
import { parseCurrency } from '../../utils/SamuiUtils';

export const soMasterModel = () => {
    return {
        docId: null,
        compId: null,
        docNo: null,
        docDate: formatThaiDateUi(moment()),
        docStatus: parseCurrency("1"),
        docStatusTransport: parseCurrency("3"),
        docStatusReceive: parseCurrency("3"),
        docCode: parseCurrency("7"),
        docType: parseCurrency("6"),
        docFor: parseCurrency("1"),
        docIsPickingList: 0,
        docIsInv: "N",
        docInvNo: null,
        docIsInvFrom: null,
        refDocID: null,
        refDoc: null,
        refDocDate: null,
        refProjectID: null,
        refProjectNo: null,
        transportType: parseCurrency("1"),
        docRemark1: null,
        docRemark2: null,
        arID: null,
        arCode: null,
        arName: null,
        docDueDate: formatThaiDateUi(moment()),
        actionHold: parseCurrency("0"),
        discountValue: parseCurrency("0"),
        discountValueType: null,
        discountValueTotal: parseCurrency("0.00"),
        discountCash: parseCurrency("0.00"),
        discountCashType: null,
        discountTransport: parseCurrency("0.00"),
        discountTransportType: null,
        isVat: null,
        docSEQ: null,
        creditTerm: null,
        creditTerm1Day: parseCurrency("0"),
        creditTerm1Remark: null,
        creditTerm2Remark: null,
        accCode: "0000",
        empName: null,
        createdDate: getCreateDateTime(),
        createdByName: window.localStorage.getItem('name'),
        createdById: window.localStorage.getItem('emp_id'),
        updateDate: null,
        updateByName: null,
        updateById: null,
        approvedDate: null,
        approvedByName: null,
        approvedById: null,
        cancelDate: null,
        cancelByName: null,
        cancelById: null,
        approvedMemo: null,
        printedStatus: "N",
        printedDate: null,
        printedBy: null,
        docPaidPic: null,
        payTotal: parseCurrency("0.00"),
        refBillNo: null,
        docSoReceiveDate: null,
    };
};